import type { PathMatcher } from './types';

export const exact =
  (path: string): PathMatcher =>
  (currentPath) =>
    currentPath === path;

export const startsWith =
  (prefix: string): PathMatcher =>
  (path) =>
    path.startsWith(prefix);

export const includes =
  (segment: string): PathMatcher =>
  (path) =>
    path.includes(segment);

export const regex =
  (pattern: RegExp): PathMatcher =>
  (path) =>
    pattern.test(path);

export const endsWith =
  (suffix: string): PathMatcher =>
  (path) =>
    path.endsWith(suffix);

export const hasId = (): PathMatcher => (path) => /\d{10,}/.test(path);

export const hasShortId = (): PathMatcher => (path) => /\d{5,}/.test(path);
export const and =
  (...matchers: PathMatcher[]): PathMatcher =>
  (path) =>
    matchers.every((matcher) => matcher(path));

export const or =
  (...matchers: PathMatcher[]): PathMatcher =>
  (path) =>
    matchers.some((matcher) => matcher(path));

export const not =
  (matcher: PathMatcher): PathMatcher =>
  (path) =>
    !matcher(path);
export const sequence =
  (...segments: string[]): PathMatcher =>
  (path) =>
    segments.every((segment) => path.includes(segment));

export const pathParams = (template: string): PathMatcher => {
  const pattern = template.replace(/:\w+/g, '\\d+');
  const regex = new RegExp(`^${pattern}$`);
  return (path) => regex.test(path);
};
export const portfolioPath = and(startsWith('/portfolios'));
export const propertyPath = and(portfolioPath, includes('/properties/'));
export const unitPath = and(propertyPath, includes('/units/'));
export const editPath = endsWith('/edit');
export const addPath = includes('/add');
export const detailPath = and(hasId(), not(editPath), not(addPath));
